import React from 'react'
import { useDispatch } from 'react-redux'
import { humanize } from '../../../../../../../../itrust_common/components/HelperFunctions'
import EyeMedFinalStep from './form/EyeMedFinalStep'
import { visionInsuranceClaimFormEdit } from '../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import { getAttachments, getAttachmentSrc } from '../eyeMedHelper'
import { normalizeEyeMedLensesForForm } from './form/lenses/eyeMedLensesPayload'

function ClaimFormOverview(props) {
  const { visionInsuranceClaimForm, claimFormTemplate, eyemedAvailableLabs = [] } = props
  const attachmentsAttributes = getAttachments(visionInsuranceClaimForm)
  const activeModulesArr = visionInsuranceClaimForm.eligibility.data.map(item => item.active && item.service_type ? item.service_type : '')
  const dispatch = useDispatch()

  const getFieldData = (key, obj, templateObj) => {
    if (obj[key] == null || obj[key] === '') return ''
    if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      const selected = obj[key].value
      const fieldInfo = templateObj?.find(item => item.label === key)
      const valLabel = fieldInfo?.options?.find(item => item.value === selected || item.label === selected)
      return valLabel?.label || selected || ''
    }
    return obj[key]
  }

  const getCheckboxFieldData = (key, obj) => {
    let data = obj[key] ? obj[key].map(item => item.label) : []
    return data.map(item => <p className='mb-3 text-muted text-break'>{item}</p>)
  }

  const getImpressionCheckbox = (key, obj) => {
    let selectedValueArr = obj[key].selected_value.map(item => item.label)
    return selectedValueArr?.map(item1 => <p className='mb-3 text-muted text-break'>{item1}</p>)
  }

  const getImpressionCptCheckbox = (key, obj) => {
    if (obj[key].cpt_codes?.length) {
      let cptCodesArr = obj[key].cpt_codes.map(item => item.label)
      return <>
        <h6 className='mt-5 mb-4'>CPT II</h6>
        {cptCodesArr?.map(item => <p className='mb-3 text-muted text-break'>{item}</p>)}
      </>
    }
  }

  const ContactLensOverview = () => {
    // Contact lens Fit & Follow Up
    return (
      <div className='mb-6 pb-6 border-bottom'>
        <h5>Contact lens Fit & Follow Up</h5>
        <div className='row'>
          {visionInsuranceClaimForm.contact_lens_fit_and_follow_up && Object.keys(visionInsuranceClaimForm.contact_lens_fit_and_follow_up)?.map(key => <div className='col-6 mt-5'>
            <h6 className='mb-4'>{humanize(key)}</h6>
            <p className='mb-3 text-muted text-break'>{getFieldData(key, visionInsuranceClaimForm?.contact_lens_fit_and_follow_up, claimFormTemplate?.config.contact_lens_fit_and_follow_up)}</p>
          </div>)}
        </div>
      </div>
    )
  }

  const ExamOverview = () => {
    const nonCheckboxFields = claimFormTemplate.config.exams.exam.filter(item => item.type !== 'checkbox')
    const checkboxFields = claimFormTemplate.config.exams.exam.filter(item => item.type == 'checkbox')

    return (
      <div className='mb-5 border-bottom pb-6'>
        <h5>Exam</h5>
        <div className='row'>
          {checkboxFields?.map((item) => <div className='col-3 mt-5'>
            <h6 className='mb-4'>{humanize(item.label)}</h6>
            {getCheckboxFieldData(item.label, visionInsuranceClaimForm?.exams.exam)}
          </div>)}
          {nonCheckboxFields.map((item) => <div className='col-3 mt-5'>
            <h6 className='mb-4'>{humanize(item.label)}</h6>
            <p className='mb-3 text-muted text-break'>{getFieldData(item.label, visionInsuranceClaimForm?.exams.exam, claimFormTemplate?.config.exams.exam)}</p>
          </div>)}
          <div className='mt-5 col-12'>
            <h6 className=''>CPT II and Disease Reporting Diagnosis:</h6>
            <div className='row'>
              {Object.keys(visionInsuranceClaimForm.exams?.impression).map((item) => {
                return (visionInsuranceClaimForm?.exams.impression[item]?.selected_value?.length || visionInsuranceClaimForm?.exams.impression[item].cpt_codes?.length) ? <div className='col-3 mt-5'>
                  <h6 className='mb-4'>{humanize(item)}</h6>
                  {getImpressionCheckbox(item, visionInsuranceClaimForm?.exams.impression)}
                  {getImpressionCptCheckbox(item, visionInsuranceClaimForm?.exams.impression)}
                </div> : ''
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const FrameOverview = () => {
    return (
      <div className='mb-5 border-bottom pb-6'>
        <h5>Frame</h5>
        <div className='row'>
          {visionInsuranceClaimForm.frames && Object.keys(visionInsuranceClaimForm.frames)?.filter(key => key !== 'attachments_attributes').map(key => <div className='col-6 mt-5' key={key}>
            <h6 className='mb-4'>{humanize(key)}</h6>
            <p className='mb-3 text-muted text-break'>{getFieldData(key, visionInsuranceClaimForm?.frames, claimFormTemplate?.config.frames)}</p>
          </div>)}
          {attachmentsAttributes?.length > 0 &&
            <div className='col-12 mt-5'>
              <h6 className='mb-4'>Attachments</h6>
              <div className='row mx-0'>
                {attachmentsAttributes.map((item, index) => (
                  <div key={item.id || index} className='col-3 d-flex flex-column align-items-center'>
                    <embed src={getAttachmentSrc(item)} className="pt-5 img-fluid" style={{ height: '12rem', objectFit: 'fit' }} />
                    <p className='text-center text-break mt-2'>{item.filename}</p>
                  </div>
                ))}
              </div>
            </div>
          }
        </div>
      </div>
    )
  }

  const LensesOverview = () => {
    const lenses = normalizeEyeMedLensesForForm(
      visionInsuranceClaimForm?.claim_data?.lenses || visionInsuranceClaimForm?.lenses || {},
      eyemedAvailableLabs,
    )
    const laboratory = lenses.laboratory
    const prescriptionFocal = lenses.prescription_focal?.value || ''
    const isManual = prescriptionFocal === 'Manual' || !!laboratory
    const eyeFields = ['sphere', 'cylinder', 'axis', 'add']
    const pdFields = [
      { key: 'distance_pd', label: 'Distance PD' },
      { key: 'near_pd', label: 'Near PD' },
      { key: 'height', label: 'Height' },
    ]

    return (
      <div className='mb-5 border-bottom pb-6'>
        <h5>Lenses</h5>
        {laboratory ? (
          <div className='row'>
            <div className='col-6 mt-5'>
              <h6 className='mb-4'>Laboratory Information</h6>
              <p className='mb-3 text-muted text-break'>Name: {laboratory.name || '-'}</p>
              <p className='mb-3 text-muted text-break'>Account: {laboratory.account || '-'}</p>
              <p className='mb-3 text-muted text-break'>Ship To: {laboratory.ship_to || '-'}</p>
            </div>
          </div>
        ) : (
          <div className='row'>
            <div className='col-6 mt-5'>
              <h6 className='mb-4'>Prescription Focal</h6>
              <p className='mb-3 text-muted text-break'>{prescriptionFocal}</p>
            </div>
          </div>
        )}
        {isManual && (
          <>
            <div className='row mt-3'>
              {['od', 'os'].map((eye) => (
                <div className='col-6 mt-5' key={eye}>
                  <h6 className='mb-4'>{eye === 'od' ? 'OD (R)' : 'OS (L)'}</h6>
                  {eyeFields.map((field) => (
                    <p className='mb-3 text-muted text-break' key={field}>
                      {humanize(field)}: {lenses[eye]?.[field] || '-'}
                    </p>
                  ))}
                </div>
              ))}
            </div>
            <div className='row mt-3'>
              {pdFields.map((field) => (
                <div className='col-4 mt-5' key={field.key}>
                  <h6 className='mb-4'>{field.label}</h6>
                  <p className='mb-3 text-muted text-break'>RE: {lenses.od?.[field.key] || '-'}</p>
                  <p className='mb-3 text-muted text-break'>LE: {lenses.os?.[field.key] || '-'}</p>
                </div>
              ))}
            </div>
          </>
        )}
        <div className='row mt-3'>
          <div className='col-4 mt-5'>
            <h6 className='mb-4'>Lens Type</h6>
            <p className='mb-3 text-muted text-break'>{lenses.lens_type || '-'}</p>
          </div>
          {lenses.lens_type === 'Progressive' ? (
            <>
              <div className='col-4 mt-5'>
                <h6 className='mb-4'>Progressive Manufacturer</h6>
                <p className='mb-3 text-muted text-break'>{lenses.progressive_manufacturer || '-'}</p>
              </div>
              <div className='col-4 mt-5'>
                <h6 className='mb-4'>Progressive Product</h6>
                <p className='mb-3 text-muted text-break'>{lenses.progressive_product || '-'}</p>
              </div>
            </>
          ) : (
            <div className='col-4 mt-5'>
              <h6 className='mb-4'>Lens Design</h6>
              <p className='mb-3 text-muted text-break'>{lenses.lens_design || '-'}</p>
            </div>
          )}
          <div className='col-4 mt-5'>
            <h6 className='mb-4'>Lens Material</h6>
            <p className='mb-3 text-muted text-break'>{lenses.lens_material || '-'}</p>
          </div>
          <div className='col-6 mt-5'>
            <h6 className='mb-4'>Frame Diagnosis</h6>
            <p className='mb-3 text-muted text-break'>{lenses.frame_diagnosis || '-'}</p>
          </div>
          <div className='col-6 mt-5'>
            <h6 className='mb-4'>Other Diagnosis</h6>
            <p className='mb-3 text-muted text-break'>{lenses.other_diagnosis || '-'}</p>
          </div>
          <div className='col-6 mt-5'>
            <h6 className='mb-4'>Standard Shape</h6>
            <p className='mb-3 text-muted text-break'>{lenses.standard_shape || '-'}</p>
          </div>
          <div className='col-6 mt-5'>
            <h6 className='mb-4'>Frame Type</h6>
            <p className='mb-3 text-muted text-break'>{lenses.frame_type || '-'}</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='mt-7'>
      <div className='bg-white p-6 border rounded'>
        <div className='d-flex justify-content-between'>
          <h3>Eyemed Insurance Claim Form</h3>
          <button className='btn btn-primary' onClick={() => dispatch(visionInsuranceClaimFormEdit({ formView: 'form', activeTab: 'first', activeModule: '' }))}>Edit Claim Form</button>
        </div>
        {claimFormTemplate && <div className='mt-7'>
          {activeModulesArr.includes('Contact Lens Fit and Follow-up') && <ContactLensOverview />}
          {activeModulesArr.includes('Exam') && <ExamOverview />}
          {activeModulesArr.includes('Frame') && <FrameOverview />}
          {activeModulesArr.includes('Lenses') && <LensesOverview />}
        </div>}
        {visionInsuranceClaimForm.claim_data?.charges && <div className='my-7'>
          <h5 className='mb-5'>Charges</h5>
          <EyeMedFinalStep visionInsuranceClaimForm={visionInsuranceClaimForm} isOverview={true} />
        </div>}
      </div>
    </div>
  )
}

export default ClaimFormOverview
